import React from 'react'
import { Spin, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const { Text } = Typography

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large'
  text?: string
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'large', 
  text = '加载中...',
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center min-h-screen ${className}`}>
      <Spin 
        indicator={<LoadingOutlined style={{ fontSize: 48, color: '#3b82f6' }} spin />}
        size={size}
      />
      {text && (
        <Text className="mt-4 text-gray-600 text-lg">
          {text}
        </Text>
      )}
    </div>
  )
}

export default LoadingSpinner
